export const GRAPHQL_VARIABLES = {
  page: 1,
  perPage: 0,
  filter: {
    status: 'draft',
    allowedPaymentTypes: ['card']
  }
};

export const QUERY = `
  query invoicesPagination ($page: Int, $perPage: Int, $filter: AutoFilledFilterFindManyinvoicesInput!, $sort: SortFindManyinvoicesInput) {
    invoicesPagination (page: $page, perPage: $perPage, filter: $filter, sort: $sort) {
        count
        items {
            customerId
            companyId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            bkInvoice
            _id
            updatedAt
            createdAt
        }
        pageInfo {
            currentPage
            perPage
            pageCount
            itemCount
            hasNextPage
            hasPreviousPage
        }
    }
  }
`;
